import type { AxiosInstance, AxiosPromise } from 'axios';
import type { Special, SpecialOffer } from './types';

export default function specialOffers(http: AxiosInstance) {
  return {
    list({ depCity }: { depCity: string }): AxiosPromise<Special[]> {
      return http.get(`/hot-offers/specials?dep_city=${depCity}`);
    },

    offers({
      id,
      depCity,
    }: {
      id: string;
      depCity: string;
    }): AxiosPromise<SpecialOffer[]> {
      return http.get(`/hot-offers/specials/${id}/offers?dep_city=${depCity}`);
    },
  };
}
